// extracted by mini-css-extract-plugin
export default {"icon":"iXqy+","iconWrapper":"zKCc-"};